<style lang='scss' rel='stylesheet/scss'>
    .loader-box {
        padding-top: 50px;
        text-align: center;
    }
    .loader-box img {
        width: 50px;
    }
</style>

<template>
    <div class="loader-box">
        <img src="/images/ajax-loader.gif">
    </div>
</template>
<script type="text/javascript">
    module.exports = {}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/loading.vue